<template>
  <v-dialog v-model="dialog" max-width="1800px" scrollable>
    <v-card>
      <v-card-title class="headline primary white--text">
        <span>Báo cáo chi tiết - {{ saleName }}</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4" style="max-height: 80vh;">
        <div v-if="loading" class="text-center pa-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <div v-else-if="detailData.length === 0" class="text-center pa-4">
          <p>Không có dữ liệu</p>
        </div>

        <div v-else>
          <div class="text-h6 mb-4">
            THÁNG {{ month }}.{{ year }}
          </div>

          <!-- Bảng tổng hợp tất cả sản phẩm -->
          <v-card outlined>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr class="grey lighten-3">
                      <th rowspan="2" class="text-center">STT</th>
                      <th rowspan="2">TÊN KH</th>
                      <th rowspan="2">MÃ BILL</th>
                      <th colspan="5" class="text-center">HÀNG NHẬP</th>
                      <th colspan="4" class="text-center">DOANH THU</th>
                      <th colspan="6" class="text-center">CHI PHÍ</th>
                      <th rowspan="2" class="text-center">CP GA TÀU + CP KHÁC</th>
                      <th rowspan="2" class="text-center">LỢI NHUẬN</th>
                    </tr>
                    <tr class="grey lighten-3">
                      <!-- Hàng nhập -->
                      <th class="text-center">Mã hàng</th>
                      <th class="text-center">KG/M3</th>
                      <th class="text-center">ĐVT</th>
                      <th class="text-right">ĐƠN GIÁ (VNĐ)</th>
                      <th class="text-right">THÀNH TIỀN (VNĐ)</th>
                      <!-- Doanh thu -->
                      <!-- <th class="text-right">ĐƠN GIÁ (VNĐ)</th>
                      <th class="text-right">THANH TIỀN (VNĐ)</th> -->
                      <th class="text-right">VẬN ĐƠN (NDT)</th>
                      <th class="text-right">XE LÔI + XE NÂNG + GIA CỐ</th>
                      <th class="text-right">CƯỚC GIAO HÀNG</th>
                      <th class="text-right">TỔNG THANH TOÁN</th>
                      <!-- Chi phí -->
                      <th class="text-right">ĐƠN GIÁ (VNĐ)</th>
                      <th class="text-right">THANH TIỀN (VNĐ)</th>
                      <th class="text-right">VẬN ĐƠN (NDT)</th>
                      <th class="text-right">XE LÔI + XE NÂNG + GIA CỐ</th>
                      <th class="text-right">CƯỚC GIAO HÀNG</th>
                      <th class="text-right">TỔNG THANH TOÁN</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(customer, cIdx) in detailData">
                      <tr v-for="(product, pIdx) in customer.Products" :key="`${cIdx}-${pIdx}`" :style="{'background-color': product.IsOverDue ? 'rgb(255 135 135 / 37%)' : ''}">
                        <td class="text-center">{{ getRowNumber(cIdx, pIdx) }}</td>
                        <td>{{ customer.CustomerUsername }}</td>
                        <td>{{ product.BillCode }}</td>
                        <!-- Hàng nhập -->
                        <td>{{ product.MainOrderCode }}</td>
                        <td class="text-center">
                          <div v-if="product.Unit === 'Kg'">
                            <div>{{ product.Weight | currency('', 1) }}</div>
                          </div>
                          <div v-else>
                            <div>{{ product.Volume | currency('', 2) }}</div>
                          </div>
                        </td>
                        <td class="text-center">{{ product.Unit }}</td>
                        <td class="text-right">
                          <span v-if="product.Unit === 'Kg'">{{ product.WeightPrice | currency }}</span>
                          <span v-else>{{ product.VolumePrice | currency }}</span>
                        </td>
                        <td class="text-right">{{ product.ImportAmount | currency }}</td>
                        <!-- Doanh thu -->
                        <!-- <td class="text-right">
                          <span v-if="product.Unit === 'Kg'">{{ product.WeightPrice | currency }}</span>
                          <span v-else>{{ product.VolumePrice | currency }}</span>
                        </td>
                        <td class="text-right">{{ product.ImportAmount | currency }}</td> -->
                        <td class="text-right">{{ product.TransportPrice | currency }}</td>
                        <td class="text-right">{{ product.FeeVehicle | currency }}</td>
                        <td class="text-right">{{ product.FeeImportVN | currency }}</td>
                        <td class="text-right font-weight-bold">{{ product.TotalRevenue | currency }}</td>
                        <!-- Chi phí -->
                        <td class="text-right">
                          <span v-if="product.Unit === 'Kg'">{{ product.WeightCost | currency }}</span>
                          <span v-else>{{ product.VolumeCost | currency }}</span>
                        </td>
                        <td class="text-right">{{ product.ImportCost | currency }}</td>
                        <td class="text-right">{{ product.TransportCost | currency }}</td>
                        <td class="text-right">{{ product.VehicleCost | currency }}</td>
                        <td class="text-right">{{ product.FeeImportVNCost | currency }}</td>
                        <td class="text-right font-weight-bold">{{ product.TotalCost | currency }}</td>
                        <!-- CP Ga tàu & khác -->
                        <td class="text-right">-</td>
                        <!-- Lợi nhuận -->
                        <td class="text-right font-weight-bold">
                          {{ (product.TotalRevenue - product.TotalCost) | currency }}
                        </td>
                      </tr>
                    </template>
                    <!-- Tổng cộng -->
                    <tr class="grey lighten-2 font-weight-bold">
                      <td colspan="3" class="text-center">TỔNG CỘNG</td>
                      <td>-</td>
                      <td class="text-center">
                        <div>{{ grandTotal.TotalWeight | currency('', 1) }}</div>
                        <div>{{ grandTotal.TotalVolume | currency('', 2) }}</div>
                      </td>
                      <td class="text-right">
                        <div>KG</div>
                        <div>M3</div>
                      </td>
                      <td class="text-right">-</td>
                      <td class="text-right">{{ grandTotal.TotalImportAmount | currency }}</td>
                      <!-- <td class="text-right">-</td>
                      <td class="text-right">{{ grandTotal.TotalImportAmount | currency }}</td> -->
                      <td class="text-right">{{ grandTotal.TotalTransportPrice | currency }}</td>
                      <td class="text-right">{{ grandTotal.TotalFeeVehicle | currency }}</td>
                      <td class="text-right">{{ grandTotal.TotalFeeImportVN | currency }}</td>
                      <td class="text-right red--text darken-2">{{ grandTotal.TotalRevenue | currency }}</td>
                      <td class="text-right">-</td>
                      <td class="text-right">{{ grandTotal.TotalImportCost | currency }}</td>
                      <td class="text-right">{{ grandTotal.TotalTransportCost | currency }}</td>
                      <td class="text-right">{{ grandTotal.TotalVehicleCost | currency }}</td>
                      <td class="text-right">{{ grandTotal.TotalFeeImportVNCost | currency }}</td>
                      <td class="text-right red--text darken-2">{{ grandTotal.TotalCost | currency }}</td>
                      <td class="text-right">-</td>
                      <td class="text-right red--text darken-2">{{ grandTotal.TotalProfit | currency }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";

export default {
  name: "SalesDetailDialog",
  data() {
    return {
      dialog: false,
      loading: false,
      detailData: [],
      saleId: null,
      saleName: '',
      month: null,
      year: null,
    };
  },
  computed: {
    grandTotal() {
      if (!this.detailData || this.detailData.length === 0) {
        return {
          TotalWeight: 0,
          TotalVolume: 0,
          TotalImportAmount: 0,
          TotalImportCost: 0,
          TotalRevenue: 0,
          TotalCost: 0,
          TotalProfit: 0,
          TotalTransportPrice: 0,
          TotalFeeVehicle: 0,
          TotalVehicleCost: 0,
          TotalFeeImportVN: 0,
          TotalTransportCost: 0,
          TotalFeeImportVNCost: 0,
        };
      }
      
      return {
        TotalWeight: _.sumBy(this.detailData, 'TotalWeight') || 0,
        TotalVolume: _.sumBy(this.detailData, 'TotalVolume') || 0,
        TotalImportAmount: _.sumBy(this.detailData, 'TotalImportAmount') || 0,
        TotalImportCost: _.sumBy(this.detailData, 'TotalImportCost') || 0,
        TotalRevenue: _.sumBy(this.detailData, 'TotalRevenue') || 0,
        TotalCost: _.sumBy(this.detailData, 'TotalCost') || 0,
        TotalProfit: _.sumBy(this.detailData, 'TotalProfit') || 0,
        TotalTransportPrice: _.sumBy(this.detailData, 'TotalTransportPrice') || 0,
        TotalFeeVehicle: _.sumBy(this.detailData, 'TotalFeeVehicle') || 0,
        TotalVehicleCost: _.sumBy(this.detailData, 'TotalVehicleCost') || 0,
        TotalFeeImportVN: _.sumBy(this.detailData, 'TotalFeeImportVN') || 0,
        TotalTransportCost: _.sumBy(this.detailData, 'TotalTransportCost') || 0,
        TotalFeeImportVNCost: _.sumBy(this.detailData, 'TotalFeeImportVNCost') || 0,
      };
    },
  },
  methods: {
    getRowNumber(customerIndex, productIndex) {
      let count = 1;
      for (let i = 0; i < customerIndex; i++) {
        count += this.detailData[i].Products.length;
      }
      return count + productIndex;
    },
    open(saleId, saleName, month, year) {
      this.saleId = saleId;
      this.saleName = saleName;
      this.month = month;
      this.year = year;
      this.dialog = true;
      this.loadDetailData();
    },
    loadDetailData() {
      this.loading = true;
      const param = {
        sale_id: this.saleId,
        month: this.month,
        year: this.year,
      };

      this.$store.dispatch("report/getSalesDetailReport", param)
        .then((data) => {
          this.detailData = data || [];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$toast.error("Không thể tải báo cáo chi tiết");
        });
    },
  },
};
</script>

<style scoped>
.v-data-table >>> th {
  font-weight: bold !important;
  /* background-color: #f5f5f5; */
  /* border: 1px solid #ddd !important; */
  color: #fff !important;
}

/* .v-data-table >>> td {
  border: 1px solid #ddd !important;
} */

.v-simple-table >>> th {
  font-weight: bold !important;
  /* background-color: #f5f5f5; */
  /* border: 1px solid #ddd !important; */
  padding: 8px !important;
  white-space: nowrap;
  color: #fff !important;
}

.v-simple-table >>> td {
  /* border: 1px solid #ddd !important; */
  padding: 8px !important;
}

.font-weight-bold td {
  font-weight: bold !important;
}
</style>
